define('taoQtiItem/qtiXmlRenderer/renderers/interactions/MediaInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/mediaInteraction'], function(tpl){
    return {
        qtiClass : 'mediaInteraction',
        template : tpl
    };
});
